import { Injectable, inject } from '@angular/core';
import { DwellingsStore } from './dwellings.facade';
import { InventoryStore } from './inventory.facade';
import { CommonAreasStore } from './common-areas.facade';
import { HabitationalUnitsStore } from './habitational-units.facade';
import { UsersStore } from './users.facade';
import { TicketsStore } from './tickets.facade';

@Injectable({ providedIn: 'root' })
export class StoreResetService {
    private readonly dwellingsStore = inject(DwellingsStore);
    private readonly commonAreasStore = inject(CommonAreasStore);
    private readonly ticketsStore = inject(TicketsStore);
    private readonly inventoryStore = inject(InventoryStore);
    private readonly usersStore = inject(UsersStore);
    private readonly habitationalUnitsStore = inject(HabitationalUnitsStore);

    resetAllSelections(): void {
        this.dwellingsStore.resetActiveDwelling();
        this.inventoryStore.resetActiveInventory();
        this.commonAreasStore.resetActiveCommonArea();
        this.habitationalUnitsStore.resetActiveHabitationalUnit();
        this.usersStore.resetActiveUser();
        this.ticketsStore.resetActiveTicket();
    }
}
